import {
  FormGroupState,
  createFormGroupState,
  updateGroup,
  validate,
  formGroupReducer,
} from 'ngrx-forms';
import { required, email } from 'ngrx-forms/validation';
import { Action } from '@ngrx/store';

// tslint:disable:interface-name
export interface AuthSignUpForm {
  email: string | null;
  password: string | null;
}

// tslint:disable:interface-name
export interface AuthSignUpState {
  form: FormGroupState<AuthSignUpForm>;
  successful: boolean | null;
  error: boolean | null | string;
}

export const AUTH_SIGN_UP_FORM_ID = 'sign-up-form';

export const AUTH_SIGN_UP_FORM_INITIAL_STATE: AuthSignUpForm = {
  email: null,
  password: null,
};

export const authSignUpInitialState: AuthSignUpState = {
  form: createFormGroupState(
    AUTH_SIGN_UP_FORM_ID,
    AUTH_SIGN_UP_FORM_INITIAL_STATE,
  ),
  successful: null,
  error: null,
};

export const authSignUpValidateAndUpdateForm = updateGroup<AuthSignUpForm>({
  email: validate(required, email),
  password: validate(required),
});

export function authSignUpReducer(
  state = authSignUpInitialState,
  action: Action,
): AuthSignUpState {
  const form = formGroupReducer(state.form, action);
  if (form !== state.form) {
    state = { ...state, form: authSignUpValidateAndUpdateForm(form) };
  }

  return state;
}
